/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown>, timecode: NonNullable<unknown> }} Audio_Description_Export_Status_Stitching_VoInputs */

const en_audio_description_export_status_stitching_vo = /** @type {(inputs: Audio_Description_Export_Status_Stitching_VoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stitching VO Track... ${i?.current}/${i?.total} | ${i?.timecode}`)
};

const fr_audio_description_export_status_stitching_vo = /** @type {(inputs: Audio_Description_Export_Status_Stitching_VoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Assemblage de la piste VO... ${i?.current}/${i?.total} | ${i?.timecode}`)
};

const de_audio_description_export_status_stitching_vo = /** @type {(inputs: Audio_Description_Export_Status_Stitching_VoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`VO-Spur wird zusammengefügt... ${i?.current}/${i?.total} | ${i?.timecode}`)
};

const it_audio_description_export_status_stitching_vo = /** @type {(inputs: Audio_Description_Export_Status_Stitching_VoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cucitura traccia VO... ${i?.current}/${i?.total} | ${i?.timecode}`)
};

const ru_audio_description_export_status_stitching_vo = /** @type {(inputs: Audio_Description_Export_Status_Stitching_VoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сшивание звуковой дорожки... ${i?.current}/${i?.total} | ${i?.timecode}`)
};

const es_audio_description_export_status_stitching_vo = /** @type {(inputs: Audio_Description_Export_Status_Stitching_VoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cosiendo pista VO... ${i?.current}/${i?.total} | ${i?.timecode}`)
};

const zh_cn2_audio_description_export_status_stitching_vo = /** @type {(inputs: Audio_Description_Export_Status_Stitching_VoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在拼接旁白音轨... ${i?.current}/${i?.total} | ${i?.timecode}`)
};

const ja_audio_description_export_status_stitching_vo = /** @type {(inputs: Audio_Description_Export_Status_Stitching_VoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`VO トラックをステッチしています... ${i?.current}/${i?.total} | ${i?.timecode}`)
};

const hi_audio_description_export_status_stitching_vo = /** @type {(inputs: Audio_Description_Export_Status_Stitching_VoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वॉयस ओवर ट्रैक को स्टिच किया जा रहा है... ${i?.current}/${i?.total} | ${i?.timecode}`)
};

const pt_pt2_audio_description_export_status_stitching_vo = /** @type {(inputs: Audio_Description_Export_Status_Stitching_VoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Costura da faixa de voz... ${i?.current}/${i?.total} | ${i?.timecode}`)
};

/**
* | output |
* | --- |
* | "Stitching VO Track... {current}/{total} \| {timecode}" |
*
* @param {Audio_Description_Export_Status_Stitching_VoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_stitching_vo = /** @type {((inputs: Audio_Description_Export_Status_Stitching_VoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Stitching_VoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_stitching_vo(inputs)
	if (locale === "de") return de_audio_description_export_status_stitching_vo(inputs)
	if (locale === "it") return it_audio_description_export_status_stitching_vo(inputs)
	if (locale === "ru") return ru_audio_description_export_status_stitching_vo(inputs)
	if (locale === "es") return es_audio_description_export_status_stitching_vo(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_stitching_vo(inputs)
	if (locale === "ja") return ja_audio_description_export_status_stitching_vo(inputs)
	if (locale === "hi") return hi_audio_description_export_status_stitching_vo(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_stitching_vo(inputs)
	return en_audio_description_export_status_stitching_vo(inputs)
});